import PageHero from '../components/PageHero';

const STEPS = [
  { n:'01', color:'#FF9933', icon:'👤', title:'Tell Us About Yourself', hindi:'अपना विवरण दें', desc:'Income, age, occupation, and state — or for a business: sector, size, and turnover. Under two minutes.' },
  { n:'02', color:'#000080', icon:'🔍', title:'See What You Qualify For', hindi:'पात्र योजनाएं देखें', desc:"We match your profile against central and state schemes and show which ones you're eligible for — and why." },
  { n:'03', color:'#138808', icon:'✅', title:'Apply Right There', hindi:'सीधे आवेदन करें', desc:'No jumping between portals. Apply from one place and track every application in a single dashboard.' },
];

export default function HowItWorks({ go }) {
  return (
    <>
      <PageHero tag="How It Works · यह कैसे काम करता है" title="From Your Details to a Submitted Application — One Flow" subtitle="आपकी जानकारी से आवेदन तक — एक ही प्रवाह में" from="#138808" to="#0A5C04" tagColor="rgba(255,255,255,.8)" />

      <section className="section section-white">
        <div className="wrap">
          <p className="how-intro">No need to search each department's website separately. Tell us once, and we do the matching. Then apply — without leaving the app.</p>

          <div className="how-steps">
            {STEPS.map(s => (
              <div key={s.n} className="step-card">
                <div className="step-icon" style={{ background:s.color }}>{s.icon}</div>
                <div className="step-num">Step {s.n}</div>
                <h3>{s.title}</h3>
                <div className="step-hindi" style={{ color:s.color }}>{s.hindi}</div>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>

          <div className="how-cta">
            <button className="btn btn-saffron" style={{ fontSize:15 }} onClick={()=>go('for-citizens')}>
              Get Started — It's Free →
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
